import React, { useState, useEffect } from 'react';

const quotes = [
  {
    text: "The world is a book and those who do not travel read only one page.",
    author: "Saint Augustine"
  },
  {
    text: "Not all those who wander are lost.",
    author: "J.R.R. Tolkien"
  },
  {
    text: "Travel makes one modest. You see what a tiny place you occupy in the world.",
    author: "Gustave Flaubert"
  },
  {
    text: "The journey of a thousand miles begins with a single step.",
    author: "Lao Tzu"
  },
  {
    text: "Jobs fill your pocket, but adventures fill your soul.",
    author: "Jamie Lyn Beatty"
  },
  {
    text: "Oh, the places you'll go.",
    author: "Dr. Seuss"
  },
  {
    text: "Travel is the only thing you buy that makes you richer.",
    author: "Anonymous"
  },
  {
    text: "A journey is best measured in friends, rather than miles.",
    author: "Tim Cahill"
  },
  {
    text: "It is not the destination where you end up, but the mishaps and memories you create along the way.",
    author: "Penelope Riley"
  },
  {
    text: "Take only memories, leave only footprints.",
    author: "Chief Seattle"
  }
];

const TravelQuotes = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsFading(true);
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % quotes.length);
        setIsFading(false);
      }, 500); // Wait for fade out before changing quote
    }, 10000); // 10 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="w-full bg-slate-900/50 backdrop-blur-sm py-8 mt-auto border-t border-slate-800">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <div 
          className={`transition-opacity duration-500 transform ${isFading ? 'opacity-0' : 'opacity-100'}`}
        >
          <p className="text-xl md:text-2xl font-light italic text-slate-200 mb-4 quotes-glow">
            "{quotes[currentIndex].text}"
          </p>
          <p className="text-sm font-semibold tracking-wider text-indigo-400 uppercase">
            — {quotes[currentIndex].author} —
          </p>
        </div>
        
        {/* Progress dots */}
        <div className="flex justify-center gap-2 mt-6">
          {quotes.map((_, idx) => (
            <div 
              key={idx}
              className={`h-1 rounded-full transition-all duration-300 ${
                idx === currentIndex ? 'w-6 bg-indigo-500' : 'w-2 bg-slate-700'
              }`}
            />
          ))}
        </div>
      </div>
      
      <style jsx>{`
        .quotes-glow {
          text-shadow: 0 0 20px rgba(99, 102, 241, 0.2);
        }
      `}</style>
    </div>
  );
};

export default TravelQuotes;
